import * as d3 from 'd3';

/**
 * Draw Tall Fractional Grilles — two vertical bars that extend ~60% of the window height from the top.
 */
export function drawTallFractionalGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  fillColor = 'white',
  strokeColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  fractionalHeightRatio = 0.6 // how tall the bars are, relative to window height
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const barHeight = glassHeight * fractionalHeightRatio;

  // Positions for the two vertical bars: 1/4 and 3/4 of the window width
  const leftBarX = glassX + glassWidth * 0.25;
  const rightBarX = glassX + glassWidth * 0.75;

  [leftBarX, rightBarX].forEach((barX) => {
    svg.append('rect')
      .attr('x', barX - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', barHeight)
      .attr('fill', fillColor)
      .attr('stroke', strokeColor)
      .attr('stroke-width', borderWidth);
  });
}
